<template>
  <detail-layout ref="layout" :tableCfg="tableCfg">
    <template slot="FormLayout" scope="props">
      <b-form ref="form" class="col-md-6 offset-md-2" autocomplete="off">
        <div v-if="dataValid" >
          <detail-field label="Short Name" field="shortname" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Name" field="name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field v-if="false" label="Registration Fee Amount" field="registration_fee_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field v-if="false" label="Invoice Amount 1" field="invoice1_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field v-if="false" label="Invoice Amount 2" field="invoice2_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field v-if="false" label="Invoice Amount 3" field="invoice3_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field v-if="false" label="Invoice Amount 4" field="invoice4_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field v-if="false" label="Monthly Allowance" field="monthly_allowance_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
        </div>
      </b-form>
    </template>
  </detail-layout>
</template>

<script>
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'program_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?07621276